export const environment = {
  appName: "WHITELOTUS ADMIN",
  production: true,

  apiUrl:'https://api.hotelgreenparksuites.com/',  //production
  media_domain: 'https://d1kr5bfvr1pyp0.cloudfront.net/greenparksuites', //production
  apiPrefix: 'api/v1',
};
